import getSkypeApi from '../chatManager/getSkypeApi';
import getMySipUri from '../../presenceManager/getMySipUri';
import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import SkypePresence from '../store/schema/SkypePresence';
import { addOrUpdatePresence } from '../../actions/presenceActions';
import updateSelfPresence from '../../presenceManager/updateSelfPresence';

let ucwaPresenceCallbacks: { [sipUri: string]: (presence: SkypePresence) => void } = {};

export default function subscribePresenceFromUcwa(sipUri: string) {
    if (!ucwaPresenceCallbacks[sipUri]) {
        getSkypeApi().then(api => {
            if (sipUri == getMySipUri()) {
                addOrUpdatePresence(sipUri, convertFromSkypePresence(api.me.status()));
            } else {
                const contact = api.contact(sipUri);
                const callback = createPresenceCallback(sipUri);
                contact.status.subscribe(callback);
            }
        });
    }
}

export function onMyPresenceChanged(presence: SkypePresence) {
    updateSelfPresence(convertFromSkypePresence(presence));
}

export function clearPresenceCallbacks() {
    ucwaPresenceCallbacks = {};
}

function convertFromSkypePresence(presence: SkypePresence): InstantMessagePresenceType {
    switch (presence) {
        case 'Online':
            return 'Online';
        case 'Offline':
        case 'Hidden':
            return 'Offline';
        case 'BeRightBack':
            return 'BeRightBack';
            break;
        case 'Away':
        case 'Idle':
            return 'Away';
        case 'Busy':
            return 'Busy';
        case 'DoNotDisturb':
            return 'DoNotDisturb';
        default:
            return 'None';
    }
}

function createPresenceCallback(sipUri: string) {
    const callback = (presence: SkypePresence) => {
        addOrUpdatePresence(sipUri, convertFromSkypePresence(presence));
        ucwaPresenceCallbacks[sipUri] = callback;
    };
    return callback;
}
